var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankNpi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299.464,
    height: 320.868,
    viewBox: "0 0 299.464 320.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0e0e0;}.b{fill:#fff;}.c{fill:#ebebeb;}.d{fill:#263238;}.e{fill:#fafafa;}.f,.g{fill:url(#a);}.g,.j{stroke:rgba(0,0,0,0);stroke-linecap:round;stroke-linejoin:round;}.h{fill:#455a64;}.i{opacity:0.3;}.j{fill:url(#s);}.k{opacity:0.6;}.l{fill:#b78876;}.m{fill:#aa6550;}.n{filter:url(#z);}.o{filter:url(#w);}.p{filter:url(#t);}.q{filter:url(#q);}.r{filter:url(#n);}.s{filter:url(#k);}.t{filter:url(#h);}.u{filter:url(#e);}.v{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.008,
    y1: 0.075,
    x2: 0.992,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4083f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#609bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b79e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#548ded"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 30.315,
    y: 103.976,
    width: 58.879,
    height: 58.879,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 29.815,
    y: 155.203,
    width: 59.879,
    height: 59.879,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 75.746,
    y: 96.285,
    width: 81.456,
    height: 31.345,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 75.746,
    y: 147.089,
    width: 81.456,
    height: 31.345,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 231.898,
    y: 66.024,
    width: 39.434,
    height: 39.433,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 238.215,
    y: 72.886,
    width: 34.412,
    height: 34.442,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.992,
    y1: 0.925,
    x2: 0.008,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    x: 7.624,
    y: 265.626,
    width: 58.234,
    height: 36.555,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "u"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "u"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    x: 10.222,
    y: 271.181,
    width: 53.148,
    height: 49.686,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "x"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "x"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "z",
    x: 107.465,
    y: 88.034,
    width: 110.497,
    height: 112.118,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "aa"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3979e9",
    floodOpacity: 0.204
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "aa"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-458.435 -93.239)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(477.67 125.825)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.173 0.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 259.374,
    height: 16.616
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.134 32.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 259.374,
    height: 145.463
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.173 6.388)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M54.681,85.246H90.294l3.529-10.277h57.729l3.529,10.277H314.055v15.735H54.681Z",
    transform: "translate(-54.681 -74.968)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.834 4.848)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M65.6,74.6a1.949,1.949,0,1,1-1.949-1.95A1.949,1.949,0,0,1,65.6,74.6Z",
    transform: "translate(-61.705 -72.649)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.867 4.848)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M74.694,74.6a1.949,1.949,0,1,1-1.949-1.95A1.949,1.949,0,0,1,74.694,74.6Z",
    transform: "translate(-70.796 -72.649)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.899 4.848)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M83.785,74.6a1.949,1.949,0,1,1-1.95-1.95A1.949,1.949,0,0,1,83.785,74.6Z",
    transform: "translate(-79.886 -72.649)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.991 19.394)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M309.625,104.445H131.678a4.938,4.938,0,0,1-4.939-4.939h0a4.938,4.938,0,0,1,4.939-4.939H309.625a4.938,4.938,0,0,1,4.939,4.939h0A4.938,4.938,0,0,1,309.625,104.445Z",
    transform: "translate(-126.739 -94.568)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.209 22.097)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M139.089,101.809v1.668h-.845v-1.538c0-.472-.217-.688-.591-.688-.406,0-.7.249-.7.786v1.441h-.845v-4.02h.845v1.408a1.28,1.28,0,0,1,.926-.346A1.142,1.142,0,0,1,139.089,101.809Z",
    transform: "translate(-136.109 -98.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M143.456,103.57a1.213,1.213,0,0,1-.688.184.961.961,0,0,1-1.089-1.045v-1.2h-.449v-.65h.449v-.709h.845v.709h.726v.65h-.726V102.7a.339.339,0,0,0,.363.384.571.571,0,0,0,.341-.108Z",
    transform: "translate(-137.832 -99.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M146.91,103.57a1.213,1.213,0,0,1-.688.184.961.961,0,0,1-1.089-1.045v-1.2h-.449v-.65h.449v-.709h.845v.709h.726v.65h-.726V102.7a.339.339,0,0,0,.363.384.571.571,0,0,0,.341-.108Z",
    transform: "translate(-138.994 -99.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M151.933,102.558a1.415,1.415,0,0,1-1.452,1.5,1.13,1.13,0,0,1-.877-.352v1.36h-.845V101.1h.808v.336a1.131,1.131,0,0,1,.915-.379A1.415,1.415,0,0,1,151.933,102.558Zm-.856,0a.745.745,0,1,0-.742.807A.735.735,0,0,0,151.077,102.558Z",
    transform: "translate(-140.364 -99.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.082,101.586a.526.526,0,0,1,1.051,0,.526.526,0,1,1-1.051,0Zm0,1.945a.526.526,0,0,1,1.051,0,.526.526,0,1,1-1.051,0Z",
    transform: "translate(-142.155 -99.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.895,98.641h.753l-1.788,5.1h-.753Z",
    transform: "translate(-142.836 -98.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M160.5,98.641h.753l-1.788,5.1h-.753Z",
    transform: "translate(-143.712 -98.641)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.764 40.532)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.162 0.173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M319.063,144.188H164.026a8.754,8.754,0,0,1-8.754-8.754h0a8.754,8.754,0,0,1,8.754-8.754H319.063a8.754,8.754,0,0,1,8.754,8.754h0A8.754,8.754,0,0,1,319.063,144.188Z",
    transform: "translate(-155.272 -126.681)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M318.981,144.1a9.239,9.239,0,0,0,3.583-.812,8.8,8.8,0,0,0,4.711-5.331,8.826,8.826,0,0,0,.362-3.2,8.61,8.61,0,0,0-3.594-6.437,8.583,8.583,0,0,0-4.01-1.563,20.31,20.31,0,0,0-2.317-.067l-2.418,0-22.289.025-129.058.05a8.583,8.583,0,0,0-4.013,16.169,8.813,8.813,0,0,0,4.3.995h8.99l34.266.011,58.022.036,39.116.055,10.635.033,2.765.017c.623.006.942.018.942.018s-.319.011-.942.017l-2.765.017-10.635.033-39.116.055-58.022.037-34.266.011h-8.99a9.166,9.166,0,0,1-4.465-1.033,8.928,8.928,0,0,1,4.173-16.817l129.058.05,22.289.025,2.418,0a20.232,20.232,0,0,1,2.338.075,8.754,8.754,0,0,1,4.085,1.607,8.768,8.768,0,0,1,1.934,12.368,8.743,8.743,0,0,1-3.481,2.8,9.042,9.042,0,0,1-2.668.713C319.3,144.1,318.981,144.1,318.981,144.1Z",
    transform: "translate(-155.029 -126.421)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.232 47.274)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M173.816,140.721l.331-.734a2.473,2.473,0,0,0,1.389.439c.577,0,.812-.192.812-.451,0-.788-2.448-.247-2.448-1.81,0-.716.577-1.311,1.775-1.311a2.821,2.821,0,0,1,1.461.373l-.3.74a2.379,2.379,0,0,0-1.167-.33c-.578,0-.8.216-.8.481,0,.776,2.448.24,2.448,1.786,0,.7-.583,1.3-1.786,1.3A3,3,0,0,1,173.816,140.721Z",
    transform: "translate(-173.816 -136.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M183.03,140.288h-2.448a.863.863,0,0,0,.926.65,1.1,1.1,0,0,0,.812-.313l.5.542a1.7,1.7,0,0,1-1.336.523,1.679,1.679,0,0,1-1.846-1.666,1.647,1.647,0,0,1,1.726-1.666,1.6,1.6,0,0,1,1.684,1.678C183.048,140.108,183.036,140.21,183.03,140.288Zm-2.46-.547h1.593a.808.808,0,0,0-1.593,0Z",
    transform: "translate(-175.774 -137.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M188.343,139.8v1.847h-.878v-.4a1.063,1.063,0,0,1-.987.451c-.758,0-1.208-.421-1.208-.98s.4-.969,1.389-.969h.746c0-.4-.24-.637-.746-.637a1.554,1.554,0,0,0-.932.3l-.337-.656a2.484,2.484,0,0,1,1.4-.391C187.772,138.358,188.343,138.815,188.343,139.8Zm-.938.824v-.33h-.644c-.439,0-.577.163-.577.379,0,.235.2.391.53.391A.691.691,0,0,0,187.4,140.619Z",
    transform: "translate(-177.669 -137.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M193.191,138.358v.866c-.078-.006-.138-.012-.21-.012a.8.8,0,0,0-.86.9v1.528h-.938v-3.236h.9v.427A1.306,1.306,0,0,1,193.191,138.358Z",
    transform: "translate(-179.658 -137.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M194.647,140.024a1.673,1.673,0,0,1,1.8-1.666,1.487,1.487,0,0,1,1.449.824l-.728.391a.806.806,0,0,0-.727-.445.9.9,0,0,0,0,1.792.8.8,0,0,0,.727-.445l.728.4a1.5,1.5,0,0,1-1.449.818A1.672,1.672,0,0,1,194.647,140.024Z",
    transform: "translate(-180.823 -137.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.64,139.192v1.853H202.7v-1.709c0-.523-.24-.764-.655-.764-.451,0-.776.277-.776.872v1.6h-.938v-4.463h.938v1.564a1.422,1.422,0,0,1,1.029-.385A1.268,1.268,0,0,1,203.64,139.192Z",
    transform: "translate(-182.736 -136.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M208.82,142.2a.584.584,0,0,1,1.167,0,.584.584,0,1,1-1.167,0Z",
    transform: "translate(-185.591 -138.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M211.2,142.2a.584.584,0,0,1,1.167,0,.584.584,0,1,1-1.167,0Z",
    transform: "translate(-186.39 -138.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M213.572,142.2a.584.584,0,0,1,1.167,0,.584.584,0,1,1-1.167,0Z",
    transform: "translate(-187.189 -138.276)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.08 73.276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.98,175.936c0,.1-6.222.173-13.9.173s-13.9-.077-13.9-.173,6.221-.173,13.9-.173S113.98,175.841,113.98,175.936Z",
    transform: "translate(-86.186 -175.763)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.08 81.39)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "v",
    transform: "matrix(1, 0, 0, 1, -40.31, -113.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 28.879,
    height: 28.879,
    rx: 4,
    transform: "translate(40.31 113.98)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.324 88.024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.986,198.16c0,.1-35.849.173-80.06.173-44.226,0-80.067-.077-80.067-.173s35.841-.173,80.067-.173C277.137,197.987,312.986,198.065,312.986,198.16Z",
    transform: "translate(-152.858 -197.987)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.926 98.897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.466,214.545c0,.1-9.447.173-21.1.173s-21.1-.077-21.1-.173,9.445-.173,21.1-.173S197.466,214.45,197.466,214.545Z",
    transform: "translate(-155.272 -214.372)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.926 108.98)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M288.2,229.738c0,.1-29.76.173-66.462.173s-66.469-.078-66.469-.173,29.754-.173,66.469-.173S288.2,229.642,288.2,229.738Z",
    transform: "translate(-155.272 -229.565)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.08 125.003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.98,253.883c0,.1-6.222.173-13.9.173s-13.9-.077-13.9-.173,6.221-.173,13.9-.173S113.98,253.787,113.98,253.883Z",
    transform: "translate(-86.186 -253.71)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.08 133.116)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "matrix(1, 0, 0, 1, -40.31, -165.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 28.879,
    height: 28.879,
    rx: 4,
    transform: "translate(40.31 165.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.324 139.751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.5,276.107c0,.1-37.979.172-84.817.172-46.854,0-84.824-.077-84.824-.172s37.97-.173,84.824-.173C284.521,275.934,322.5,276.011,322.5,276.107Z",
    transform: "translate(-152.858 -275.934)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.926 150.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.466,292.492c0,.1-9.447.173-21.1.173s-21.1-.077-21.1-.173,9.445-.173,21.1-.173S197.466,292.4,197.466,292.492Z",
    transform: "translate(-155.272 -292.319)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.926 160.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M311.354,307.684c0,.1-34.943.173-78.037.173s-78.045-.078-78.045-.173,34.936-.173,78.045-.173S311.354,307.589,311.354,307.684Z",
    transform: "translate(-155.272 -307.511)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M313.968,243.206c0-1.137-.054-69.541-.139-177.689l.139.139-259.353.034h-.021l.173-.173c-.005,63.424-.01,123.688-.015,177.689l-.158-.157,259.374.157-259.374.158h-.158v-.159c0-54-.009-114.265-.015-177.689v-.173h.194l259.353.035h.139v.139C314.022,173.664,313.969,242.07,313.968,243.206Z",
    transform: "translate(-54.421 -65.343)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.134 12.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.368,84.916c0,.095-9.158.173-20.453.173s-20.455-.078-20.455-.173,9.156-.173,20.455-.173S169.368,84.821,169.368,84.916Z",
    transform: "translate(-128.461 -84.743)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.813 45.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 36.327,
    height: 10.943
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.01 74.198)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "t",
    transform: "matrix(1, 0, 0, 1, -86.25, -106.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M205.855,177.326c0,.1-11.3.173-25.227.173s-25.229-.077-25.229-.173,11.293-.173,25.229-.173S205.855,177.23,205.855,177.326Z",
    transform: "translate(-69.15 -70.37)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.01 125.003)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "matrix(1, 0, 0, 1, -86.25, -157.59)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M205.855,253.883c0,.1-11.3.173-25.227.173s-25.229-.077-25.229-.173,11.293-.173,25.229-.173S205.855,253.787,205.855,253.883Z",
    transform: "translate(-69.15 -96.12)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.163 43.938)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "matrix(1, 0, 0, 1, -242.4, -76.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M394.923,139.986a4.217,4.217,0,1,1,4.217-4.217A4.221,4.221,0,0,1,394.923,139.986Zm0-7.77a3.553,3.553,0,1,0,3.554,3.553A3.557,3.557,0,0,0,394.923,132.217Z",
    transform: "translate(-148.31 -55.03)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.317 6.912)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "matrix(1, 0, 0, 1, -248.72, -83.44)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M403.3,145.361a.332.332,0,0,1-.234-.1l-2.747-2.728a.332.332,0,0,1,.468-.471l2.747,2.728a.331.331,0,0,1,0,.469A.327.327,0,0,1,403.3,145.361Z",
    transform: "translate(-151.51 -58.53)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.348 98.151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.275,213.42c0,.1-10.867.173-24.27.173s-24.272-.078-24.272-.173,10.865-.173,24.272-.173S275.275,213.325,275.275,213.42Z",
    transform: "translate(-226.733 -213.247)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.865 97.404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.275,212.295c0,.1-5.684.173-12.695.173s-12.7-.077-12.7-.173,5.683-.173,12.7-.173S334.275,212.2,334.275,212.295Z",
    transform: "translate(-308.884 -212.122)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.118 150.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.929,292.492c0,.1-10.868.173-24.27.173s-24.272-.077-24.272-.173,10.865-.173,24.272-.173S274.929,292.4,274.929,292.492Z",
    transform: "translate(-226.386 -292.319)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.435 287.82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.7 2.459)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M92.613,313.16c-5.384,2.789-9.512,7.59-12.481,12.877s-4.882,11.088-6.777,16.848L71.7,372.59c6.264-10.657,11.293-23.186,12.651-35.473l-4.169-.372a9.975,9.975,0,0,0,6.634-4.853,29.545,29.545,0,0,0,3.011-7.9l-5.086.756A18.848,18.848,0,0,0,92.613,313.16Z",
    transform: "translate(-71.697 -313.16)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(30.7 2.459)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.613,313.16c-5.384,2.789-9.512,7.59-12.481,12.877s-4.882,11.088-6.777,16.848L71.7,372.59c6.264-10.657,11.293-23.186,12.651-35.473l-4.169-.372a9.975,9.975,0,0,0,6.634-4.853,29.545,29.545,0,0,0,3.011-7.9l-5.086.756A18.848,18.848,0,0,0,92.613,313.16Z",
    transform: "translate(-71.697 -313.16)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.304)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M63.472,378.3s-13.6-16.275-13.44-31.812h5.493s-5.967-3.923-5.494-6.12.629-10.515.629-10.515l5.022,1.256s-3.766-1.883-4.237-4.865,1.1-16.793,1.1-16.793,6.12,6.434,8,13.026,6.826,14.282,5.375,34.369S63.472,378.3,63.472,378.3Z",
    transform: "translate(-50.004 -309.454)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.661 17.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M80.684,388.823s14.732-9.814,18.005-22.34l-4.416-1.2s5.655-1.849,5.756-3.719,1.8-8.591,1.8-8.591l-4.313-.09s3.44-.69,4.471-2.984,2.79-13.741,2.79-13.741-6.328,3.834-9.285,8.721-8.613,9.988-11.841,26.456S80.684,388.823,80.684,388.823Z",
    transform: "translate(-80.679 -336.157)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.555 14.19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M59.426,330.837a.666.666,0,0,1,.053.168l.123.5c.106.467.253,1.112.439,1.93.38,1.676.883,4.112,1.46,7.131,1.16,6.036,2.531,14.422,3.612,23.74s1.652,17.8,1.9,23.942c.127,3.071.193,5.557.206,7.275.005.838.009,1.5.012,1.979,0,.21,0,.379-.005.515a.663.663,0,0,1-.014.175.658.658,0,0,1-.021-.175c-.008-.136-.017-.305-.029-.514-.019-.478-.044-1.139-.077-1.977-.054-1.717-.157-4.2-.315-7.267-.31-6.134-.926-14.6-2-23.913s-2.412-17.692-3.509-23.735c-.545-3.022-1.012-5.463-1.351-7.148-.159-.823-.285-1.472-.376-1.942-.036-.206-.066-.373-.09-.507A.674.674,0,0,1,59.426,330.837Z",
    transform: "translate(-59.424 -330.837)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 40.841)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M53.321,408.972s-12.443-14.119-16.307-22.654l2.917-1.246a7.558,7.558,0,0,1-5.919-1.94,22.4,22.4,0,0,1-4.023-4.983l3.842-.649a14.288,14.288,0,0,1-8.4-6.5,23.885,23.885,0,0,1,12.017,6.349,59.835,59.835,0,0,1,7.281,8.437,28.718,28.718,0,0,1,2.828,4.649C49.652,394.755,53.329,403.787,53.321,408.972Z",
    transform: "translate(-25.435 -370.997)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.364 25.938)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M97.213,348.54a.516.516,0,0,1-.053.146l-.187.412q-.276.578-.75,1.57c-.662,1.358-1.6,3.332-2.742,5.78-2.283,4.9-5.293,11.726-8.268,19.411s-5.337,14.769-6.942,19.926c-.8,2.578-1.436,4.671-1.859,6.121q-.318,1.051-.5,1.666l-.139.431a.5.5,0,0,1-.059.143.51.51,0,0,1,.025-.153l.106-.441.439-1.684c.384-1.462.981-3.567,1.755-6.156,1.546-5.18,3.88-12.28,6.854-19.979s6.028-14.518,8.369-19.39c1.169-2.437,2.143-4.4,2.843-5.736l.808-1.542.218-.4A.514.514,0,0,1,97.213,348.54Z",
    transform: "translate(-75.711 -348.54)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.828 60.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M64.428,425.1a5.814,5.814,0,0,1-.2-1.007c-.1-.651-.267-1.589-.5-2.742a56.074,56.074,0,0,0-6.461-17.112c-.588-1.018-1.083-1.833-1.438-2.388a5.9,5.9,0,0,1-.516-.887,5.8,5.8,0,0,1,.628.812c.391.533.919,1.331,1.537,2.337a49.769,49.769,0,0,1,6.491,17.191c.2,1.164.332,2.112.392,2.77A5.778,5.778,0,0,1,64.428,425.1Z",
    transform: "translate(-55.314 -400.968)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.124 81.545)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "matrix(1, 0, 0, 1, -18.12, -276.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 27.234,
    height: 5.555,
    rx: 2.778,
    transform: "translate(18.12 276.13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.722 87.1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "matrix(1, 0, 0, 1, -20.72, -281.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M56.661,440.706l2.946,18.686H76.064l2.746-18.686Z",
    transform: "translate(-35.94 -159.02)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.678 86.927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M79.608,440.618c0,.1-5.152.172-11.506.172s-11.507-.077-11.507-.172,5.151-.173,11.507-.173S79.608,440.523,79.608,440.618Z",
    transform: "translate(-56.595 -440.445)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(575.9 145.219)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.844 234.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M270.02,448.086v13.783l27.793-.135c-.2-2.8-15.456-8.371-15.456-8.371l.3-5.277Z",
    transform: "translate(-270.02 -448.086)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(3.707 3.976)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M276.394,454.131a1.205,1.205,0,0,0-.761,1.377,1.083,1.083,0,0,0,1.282.812,1.272,1.272,0,0,0,.8-1.463,1.109,1.109,0,0,0-1.422-.688",
    transform: "translate(-275.606 -454.078)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.581)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M270.02,467.739v-2.2l26.535.314s1.384.833,1.258,1.753Z",
    transform: "translate(-270.02 -465.537)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.839 5.418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M287.344,456.375c0,.143-.676.218-1.334.688-.67.452-1,1.076-1.128,1.021-.125-.026.064-.883.87-1.437S287.372,456.244,287.344,456.375Z",
    transform: "translate(-284.847 -456.25)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.172 6.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M293.182,458.333c.033.138-.548.39-1,1-.466.6-.573,1.253-.707,1.249-.127.025-.232-.812.341-1.561S293.177,458.2,293.182,458.333Z",
    transform: "translate(-291.376 -458.277)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.446 7.849)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M296.48,462.4c-.123.032-.321-.679.015-1.467s.962-1.11,1.021-.991c.078.116-.326.543-.592,1.194S296.613,462.38,296.48,462.4Z",
    transform: "translate(-296.309 -459.913)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.195 1.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M286.748,450.283c-.055.131-.677-.057-1.439.009-.764.05-1.354.331-1.425.209-.08-.1.492-.64,1.391-.705S286.812,450.17,286.748,450.283Z",
    transform: "translate(-283.876 -449.788)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.816 236.368)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M286.789,455.143a2.029,2.029,0,0,0,.06-.842,4.671,4.671,0,0,0-.736-2.173,4.275,4.275,0,0,0-1.087-1.144.942.942,0,0,0-.938-.165,1.059,1.059,0,0,0-.547.908,3.645,3.645,0,0,0,2.442,3.225,3.484,3.484,0,0,0,3.754-1.115,2.534,2.534,0,0,0,.5-.851.917.917,0,0,0,0-.551.656.656,0,0,0-.378-.4,1.177,1.177,0,0,0-.866.086,5.158,5.158,0,0,0-.647.369,5.8,5.8,0,0,0-1.589,1.572,2.167,2.167,0,0,0-.383.739,8.023,8.023,0,0,1,2.116-2.057c.372-.214.859-.52,1.253-.384.172.071.24.273.158.515a2.2,2.2,0,0,1-.437.7,3.157,3.157,0,0,1-3.361.975,3.31,3.31,0,0,1-2.2-2.8.688.688,0,0,1,.327-.6.634.634,0,0,1,.619.123,4.069,4.069,0,0,1,1.035,1.023,4.868,4.868,0,0,1,.811,2.019C286.772,454.842,286.756,455.141,286.789,455.143Z",
    transform: "translate(-283.54 -450.751)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.052 235.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M249.324,450.406l.471,3.546-.315,8-10.42.254-.371-8.253,1.185-4.9Z",
    transform: "translate(-238.689 -449.049)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.677 236.596)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M247.18,462.037c-.064,0,.086-2.444.335-5.465s.5-5.473.565-5.477-.087,2.443-.335,5.466S247.243,462.033,247.18,462.037Z",
    transform: "translate(-247.165 -451.095)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.358 246.808)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.676,466.484l-10.527.122v1.464l10.534-.013Z",
    transform: "translate(-239.149 -466.484)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.382 239.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M239.187,457.978a1.4,1.4,0,0,1,.267-.422,7.224,7.224,0,0,1,.928-.994,7.064,7.064,0,0,1,1.683-1.129,5.546,5.546,0,0,1,6.493,1.2,4.752,4.752,0,0,1,.763,1.133,1.33,1.33,0,0,1,.166.472,10.855,10.855,0,0,0-1.091-1.452,5.549,5.549,0,0,0-3.906-1.6,6.379,6.379,0,0,0-3.963,1.547C239.655,457.443,239.231,458.014,239.187,457.978Z",
    transform: "translate(-239.185 -454.869)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.153)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.384 8.949)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M247.063,112.488l-.11,36.025,15.456.737.447-8.762s5.489,1.09,6.906-4.008c.905-3.256.679-28.425.679-28.425Z",
    transform: "translate(-246.953 -108.054)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.227 3.915)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M269.859,108.039c-2.435.7-2.963,4.676-2.963,4.676l-3.818,8.433c-1.945-1.523-4.557-1.435-5.051,1.983-.358,2.47,2.714,2.969,2.714,2.969-1.788,3.043-3,5.5-5.6,8.4-2.817,3.132-4.4,3.448-7.451,3.5h-3.369s-1.649-5.353-4.7-18.742c-3.388-14.854,14.175-12.94,17.431-16.731C262.347,96.349,277.533,105.843,269.859,108.039Z",
    transform: "translate(-239.181 -100.468)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M273.02,102.828a3.372,3.372,0,0,0-3.365-2.8,2.1,2.1,0,0,0-.437-2.666,3.424,3.424,0,0,0-2.783-.679,10.131,10.131,0,0,0-2.774,1,4.682,4.682,0,0,0-1.79-2.37,5.4,5.4,0,0,0-2.982-.739c-4.743,0-7.243,3.249-9.787,6.558a3.976,3.976,0,0,1-1.538,1.459,4.176,4.176,0,0,1-1.433.161,10.311,10.311,0,0,0-8.769,5.453c-1.661,3.209-2.9,10.635,1.4,15.239l2.591,5.782,24.774-19.63a3.556,3.556,0,0,0,2.924.22,3.132,3.132,0,0,0,1.722-4.165C271.005,105.522,273.272,104.409,273.02,102.828Z",
    transform: "translate(-235.826 -94.568)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.068 27.566)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M256.714,136.108a7.273,7.273,0,0,1-1.181,5.245c-.1-.052.392-1.155.711-2.6S256.6,136.111,256.714,136.108Z",
    transform: "translate(-255.519 -136.108)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.15 25.799)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M259.638,133.444a10.174,10.174,0,0,1-.959,5.142,14.037,14.037,0,0,1,.431-2.58A14.112,14.112,0,0,1,259.638,133.444Z",
    transform: "translate(-258.656 -133.444)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.535 19.849)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M266.2,124.483c.037.052-.4.37-.956,1.022a9.9,9.9,0,0,0-1.666,2.874,24.234,24.234,0,0,0-.923,3.24,5.447,5.447,0,0,1-.383,1.362,4.857,4.857,0,0,1,.111-1.414,15.875,15.875,0,0,1,.83-3.329,8.394,8.394,0,0,1,1.828-2.922A2.928,2.928,0,0,1,266.2,124.483Z",
    transform: "translate(-262.25 -124.479)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.044 15.805)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M270.65,118.385a2,2,0,0,1,.3.975,6.485,6.485,0,0,1-1.176,4.692c-.38.506-.69.75-.724.718a13.531,13.531,0,0,0,1.386-3.046A13.452,13.452,0,0,0,270.65,118.385Z",
    transform: "translate(-269.043 -118.385)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.276 23.701)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M242.691,131.385c-.052.095-.526-.07-1.057-.366s-.918-.613-.866-.708.526.07,1.057.366S242.744,131.291,242.691,131.385Z",
    transform: "translate(-240.763 -130.284)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.04 20.956)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M254.093,126.147c.1.015.039.778-.441,1.567s-1.121,1.2-1.182,1.12.413-.595.847-1.323S253.983,126.122,254.093,126.147Z",
    transform: "translate(-252.463 -126.146)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.815 19.722)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M257.289,124.288a3.092,3.092,0,0,1-.688,1.873c-.619.94-1.4,1.445-1.459,1.362s.553-.695,1.132-1.578A16.015,16.015,0,0,1,257.289,124.288Z",
    transform: "translate(-255.137 -124.288)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.777 3.141)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M265.134,100.8c-.027.031-.29-.22-.847-.538a5.719,5.719,0,0,0-2.589-.67,6.942,6.942,0,0,0-3.8,1.021,9.414,9.414,0,0,0-3.236,3.6,16.186,16.186,0,0,0-1.313,3.378l-.062.226-.208-.109a7.692,7.692,0,0,0-3.448-.882,8.151,8.151,0,0,0-2.807.423,11.95,11.95,0,0,0-2.292,1.147,2.389,2.389,0,0,1,.517-.459,7.161,7.161,0,0,1,1.7-.91,8.029,8.029,0,0,1,2.89-.523,7.858,7.858,0,0,1,3.621.872l-.269.117a15.9,15.9,0,0,1,1.331-3.467,9.555,9.555,0,0,1,3.394-3.728,7.057,7.057,0,0,1,4-.989,5.5,5.5,0,0,1,2.655.815,4.027,4.027,0,0,1,.594.471C265.083,100.719,265.144,100.786,265.134,100.8Z",
    transform: "translate(-244.531 -99.301)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.004 6.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M278.446,104.251c-.027-.007.43-.115.887.4a1.539,1.539,0,0,1,.356,1.128,1.755,1.755,0,0,1-.9,1.283,2.548,2.548,0,0,1-1.877.258,5.441,5.441,0,0,1-1.937-.939,19.2,19.2,0,0,0-1.895-1.3,7.9,7.9,0,0,0-2.284-.8,9.648,9.648,0,0,0-4.66.319,12.774,12.774,0,0,0-3.445,1.751,35.2,35.2,0,0,0-2.749,2.327,3.93,3.93,0,0,1,.611-.762,14.9,14.9,0,0,1,1.976-1.789,12.371,12.371,0,0,1,3.5-1.87,9.775,9.775,0,0,1,4.844-.361,8.123,8.123,0,0,1,2.4.851,18.225,18.225,0,0,1,1.919,1.34,5.212,5.212,0,0,0,1.8.916,2.273,2.273,0,0,0,1.667-.182,1.533,1.533,0,0,0,.819-1.07,1.4,1.4,0,0,0-.258-1.007A1.36,1.36,0,0,0,278.446,104.251Z",
    transform: "translate(-259.942 -103.743)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.659 34.181)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M358.817,146.131c-.583-.518-8.454,2.784-8.454,2.784a87.6,87.6,0,0,0-8.289,7.328l-1.493,1.242-22.335,17.369-27.474-11.429-5.961,15.327s30.843,12.278,35.542,10.176c5.107-2.284,24.119-22.182,24.163-22.25h0l2.745-2.645s1.453-.029,2.554-.094,4.326-2.208,4.326-2.208a6.274,6.274,0,0,0,.625-1.879,1.2,1.2,0,0,0-.6-1.364,3.08,3.08,0,0,0-1.241-3.444,2.762,2.762,0,0,0,.734-1.388c.272-1.011-1.037-1.964-1.037-1.964s4.567-3.106,5.677-3.651S359.4,146.649,358.817,146.131Z",
    transform: "translate(-284.81 -146.076)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.027 116.811)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M275.228,344.983c.092-1.009.142-1.784.142-2.27l3.1-49.527s-2.608-14.463-3.841-18.3l-11.091-4.293-14.774,5.755-.159-1.924-21.762,7.522s-.563,14.846,0,19.366c.181,1.451.751,5.2,1.439,9.621h0s.7,9.6.845,10.14c.527,1.958.649,6.753.649,11.558,0,6.107.332,13.372.713,16.827s.565,41.435.565,41.435h16.058l2.062-60.5c.346-6.483.865-16.4,1.2-23.57l3.772,22.337c0,.82,2.294,13.591,2.294,13.591a120.24,120.24,0,0,0-.984,12.118c-.265,11.259-1.588,36.023-1.588,36.023h15.719s4.72-35.76,5.639-45.908h0Z",
    transform: "translate(-226.596 -270.591)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.398 11.946)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M299.932,296.273a6.049,6.049,0,0,1-1.449-.772,20.115,20.115,0,0,1-5.669-5.485,6.049,6.049,0,0,1-.819-1.422,11.2,11.2,0,0,1,1.013,1.281,26.682,26.682,0,0,0,5.61,5.428A11.235,11.235,0,0,1,299.932,296.273Z",
    transform: "translate(-291.993 -288.592)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.512 14.342)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M260.3,306.488a1.906,1.906,0,0,1-.308-.494c-.182-.326-.415-.815-.676-1.43a23.434,23.434,0,0,1-1.78-10.218,15.727,15.727,0,0,1,.153-1.574,1.927,1.927,0,0,1,.123-.569c.055.006-.022.826-.036,2.15a27.944,27.944,0,0,0,1.764,10.123C260,305.717,260.352,306.463,260.3,306.488Z",
    transform: "translate(-257.506 -292.203)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.913 25.108)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M263.349,330.593a4.294,4.294,0,0,1-.206-.861c-.116-.63-.261-1.424-.435-2.37-.349-2.078-.809-4.814-1.317-7.837-.888-5.556-1.492-9.339-1.774-11.1a16.369,16.369,0,0,1,.759,3.207c.383,2,.865,4.768,1.366,7.833s.926,5.842,1.215,7.855c.129.954.237,1.753.323,2.388A4.224,4.224,0,0,1,263.349,330.593Z",
    transform: "translate(-259.616 -308.426)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.246 81.478)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M206.852,217.347s-2.122,14.927-2.517,20.158c-.239,3.149,2.959,7.33,5.4,7.635,2.48.311,10.673.8,10.673.8l.682-9.362-.213-1.862-2.555-.481.77-14.848Z",
    transform: "translate(-204.322 -217.347)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.486 2.538)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M225.592,221.171a3.509,3.509,0,0,1,.1.811c.039.523.072,1.281.091,2.219.043,1.875,0,4.468-.161,7.324s-.388,5.436-.574,7.3c-.093.932-.177,1.686-.243,2.206a3.653,3.653,0,0,1-.138.8,3.594,3.594,0,0,1,0-.816c.035-.6.079-1.338.13-2.214.125-1.948.289-4.489.469-7.3.161-2.85.243-5.433.265-7.3.009-.877.016-1.619.022-2.216A3.665,3.665,0,0,1,225.592,221.171Z",
    transform: "translate(-224.644 -221.171)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(16.361 122.527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.223,285.112a30.339,30.339,0,0,0,13.205,1.295c4.442-.389,8.829-1.277,13.269-1.7a63.645,63.645,0,0,1,20.1,1.3,3.6,3.6,0,0,0,1.417.135,1.187,1.187,0,0,0,1.006-.889c.115-.742-.7-1.26-1.39-1.551a59.275,59.275,0,0,0-47.732,1.067",
    transform: "translate(-227.099 -279.204)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 46.054)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, -117.47, -98.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M282.941,176.226l-23.568-11.735a76.826,76.826,0,0,0-11.2-.489h-15.6s-18.9,5.576-22.025,10.715l-8.1,24.29,16.016,2.42h0l2,17.45s-1.988,20.206-1.988,23.143a21.582,21.582,0,0,0,.251,4.058s32.048-4.873,39.939-2.3,10.025,2.3,10.025,2.3-.66-8.387-1.245-13.253l-1.83-24.35-1.351-18.592,14.831,4.539Z",
    transform: "translate(-84.98 -65.93)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.397 20.521)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M223.077,212.018c-.059.007-.216-1.005-.571-2.619a44.513,44.513,0,0,0-1.854-6.2,49.9,49.9,0,0,0-2.749-5.917l-.968-1.741a2.919,2.919,0,0,1-.328-.655,3,3,0,0,1,.451.591c.272.39.641.97,1.073,1.7a39.455,39.455,0,0,1,2.864,5.915,35.673,35.673,0,0,1,1.764,6.262c.145.818.242,1.482.283,1.943A2.757,2.757,0,0,1,223.077,212.018Z",
    transform: "translate(-216.604 -194.889)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.717 44.546)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M262.591,231.094a1.245,1.245,0,0,1-.083.321l-.3.9c-.131.39-.3.864-.52,1.4s-.449,1.167-.755,1.836c-.577,1.354-1.344,2.931-2.272,4.642a57.653,57.653,0,0,1-7.247,10.357c-1.29,1.458-2.509,2.719-3.583,3.725-.524.517-1.031.948-1.465,1.338s-.82.713-1.142.97l-.741.589a1.2,1.2,0,0,1-.273.188c-.007-.009.072-.092.229-.24l.7-.637c.308-.271.682-.606,1.1-1.01s.915-.845,1.426-1.37c1.048-1.024,2.243-2.3,3.514-3.757,1.256-1.473,2.579-3.142,3.866-4.969s2.39-3.65,3.343-5.334c.937-1.694,1.723-3.253,2.326-4.588.318-.66.565-1.275.8-1.809s.423-1,.572-1.38l.36-.875A1.214,1.214,0,0,1,262.591,231.094Z",
    transform: "translate(-244.21 -231.094)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.312 2.134)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M287.469,167.183a7.615,7.615,0,0,0-1.242,2.958,10.338,10.338,0,0,0,.023,3.483,41.062,41.062,0,0,0,1,4.208c.814,2.97,1.675,5.623,2.328,7.533l.782,2.26a4.235,4.235,0,0,1,.254.842,4.079,4.079,0,0,1-.384-.792c-.223-.52-.532-1.279-.889-2.225-.715-1.893-1.618-4.543-2.434-7.524a36.756,36.756,0,0,1-.977-4.254,10.1,10.1,0,0,1,.056-3.58,6.49,6.49,0,0,1,.912-2.237A2.5,2.5,0,0,1,287.469,167.183Z",
    transform: "translate(-285.793 -167.182)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.373 72.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M216.665,205.007a3.322,3.322,0,0,1-1.256.853,6.339,6.339,0,0,1-6.934-1.055,3.328,3.328,0,0,1-.946-1.188c.047-.036.39.432,1.1,1a6.659,6.659,0,0,0,6.681,1.017C216.164,205.3,216.631,204.959,216.665,205.007Z",
    transform: "translate(-207.527 -203.615)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.463 62.799)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M265.942,189.2a3.189,3.189,0,0,1-.2.51c-.143.33-.37.808-.7,1.408a19.23,19.23,0,0,1-3.5,4.584,15.84,15.84,0,0,1-7.48,4.071,13.968,13.968,0,0,1-5.073.218,14.956,14.956,0,0,1-5.133-1.825c-3.259-1.82-6.01-4.123-9.024-5.223a14.16,14.16,0,0,0-8.32-.459,14.822,14.822,0,0,0-5.17,2.37c-1.088.807-1.6,1.368-1.629,1.337a10.2,10.2,0,0,1,1.548-1.444,14.556,14.556,0,0,1,13.682-2.1c3.085,1.112,5.862,3.427,9.078,5.219a14.723,14.723,0,0,0,5.016,1.792,13.746,13.746,0,0,0,4.955-.194,15.765,15.765,0,0,0,7.381-3.938,20.132,20.132,0,0,0,3.555-4.472c.341-.586.587-1.053.749-1.372A3.307,3.307,0,0,1,265.942,189.2Z",
    transform: "translate(-219.717 -189.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.323 54.288)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M308,176.375a3.125,3.125,0,0,1,.307.764,9.234,9.234,0,0,1,.382,2.214,10.258,10.258,0,0,1-.37,3.317,10.084,10.084,0,0,1-1.865,3.639,26.465,26.465,0,0,1-2.958,2.8,7.926,7.926,0,0,0-2.007,2.529,4.308,4.308,0,0,0-.44,2.112c.04.516.149.791.118.8-.011,0-.044-.061-.1-.191a2.54,2.54,0,0,1-.153-.6,4.166,4.166,0,0,1,.35-2.226,7.855,7.855,0,0,1,2.015-2.664,28.88,28.88,0,0,0,2.905-2.781,10.449,10.449,0,0,0,2.259-6.729A15.6,15.6,0,0,0,308,176.375Z",
    transform: "translate(-300.879 -176.375)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.418 105.892)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M245.383,258.481a2.81,2.81,0,0,1-.691.24,14.725,14.725,0,0,1-1.953.417,6.888,6.888,0,0,1-2.978-.174,4.439,4.439,0,0,1-1.562-.879,13.337,13.337,0,0,1-1.274-1.394,6.606,6.606,0,0,0-1.333-1.23,6.248,6.248,0,0,0-1.521-.729,6.691,6.691,0,0,0-2.846-.273,6.088,6.088,0,0,0-1.873.528,4.667,4.667,0,0,1-.66.3,2.209,2.209,0,0,1,.6-.424,5.479,5.479,0,0,1,1.9-.65,6.654,6.654,0,0,1,2.975.211,6.41,6.41,0,0,1,1.613.751,6.789,6.789,0,0,1,1.408,1.287,13.819,13.819,0,0,0,1.236,1.366,4.18,4.18,0,0,0,1.437.83,6.942,6.942,0,0,0,2.851.234C244.361,258.706,245.369,258.416,245.383,258.481Z",
    transform: "translate(-228.691 -254.138)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.679 102.174)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.691,255.178c.007.009-.065.07-.21.179a5.994,5.994,0,0,1-.654.442,9.852,9.852,0,0,1-2.682,1.122,11.307,11.307,0,0,1-4.306.249,10.589,10.589,0,0,1-4.9-1.964,49.15,49.15,0,0,1-3.915-3.52,12.61,12.61,0,0,0-3.475-2.394,6.663,6.663,0,0,0-2.76-.611c-.674.011-1.043.113-1.05.078a.812.812,0,0,1,.262-.09,3.889,3.889,0,0,1,.783-.123,6.386,6.386,0,0,1,2.86.52,12.392,12.392,0,0,1,3.593,2.384c1.214,1.074,2.421,2.386,3.9,3.477a10.479,10.479,0,0,0,4.736,1.928,11.444,11.444,0,0,0,4.2-.171,10.873,10.873,0,0,0,2.674-1A10.564,10.564,0,0,1,287.691,255.178Z",
    transform: "translate(-263.743 -248.535)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(677.617 93.239)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.713)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M375.041,83.35a33.927,33.927,0,1,1,44.347-46.981h0A33.922,33.922,0,0,1,375.041,83.35Zm28.279-59.158A31.634,31.634,0,1,0,417.4,37.466,31.644,31.644,0,0,0,403.319,24.192Z",
    transform: "translate(-355.721 -18.82)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.471 60.262)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M456.863,150.985h0a4.218,4.218,0,0,1-5.8-1.375l-22.188-35.956a.724.724,0,0,1,.236-1l4.734-2.921a.724.724,0,0,1,.983.216l23.337,35.108A4.218,4.218,0,0,1,456.863,150.985Z",
    transform: "translate(-428.763 -109.628)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M376.27,80.769a33.927,33.927,0,1,1,44.348-46.98h0a33.922,33.922,0,0,1-44.348,46.98Zm28.279-59.157a31.633,31.633,0,1,0,14.079,13.273A31.641,31.641,0,0,0,404.548,21.612Z",
    transform: "translate(-356.951 -16.239)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.202 60.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M0,0H6.986a0,0,0,0,1,0,0V44.731a3.493,3.493,0,0,1-3.493,3.493h0A3.494,3.494,0,0,1,0,44.73V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 3.668) rotate(-31.669)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.43 7.49)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M369.935,45.9a6.611,6.611,0,0,1,.188-1.047,9.585,9.585,0,0,1,.313-1.21,15.667,15.667,0,0,1,.53-1.57l.356-.9c.126-.311.293-.618.447-.946a23.044,23.044,0,0,1,1.108-2.025,24.208,24.208,0,0,1,7.327-7.529c.693-.426,1.342-.848,1.995-1.163.323-.163.626-.337.933-.472l.887-.38a15.677,15.677,0,0,1,1.556-.572,9.488,9.488,0,0,1,1.2-.346,6.611,6.611,0,0,1,1.042-.218,6.669,6.669,0,0,1-1.008.339,11.186,11.186,0,0,0-1.177.4c-.451.176-.977.342-1.524.612l-.869.395c-.3.139-.6.318-.914.484-.64.321-1.275.747-1.956,1.174a24.977,24.977,0,0,0-7.239,7.438c-.409.691-.818,1.338-1.12,1.987-.157.321-.328.622-.459.927l-.371.879c-.255.554-.407,1.084-.57,1.54a11.171,11.171,0,0,0-.364,1.187A6.745,6.745,0,0,1,369.935,45.9Z",
    transform: "translate(-369.931 -27.526)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankNpi);
export default __webpack_public_path__ + "static/media/BlankNpi.9a53269c0c77792de905e286c10ca2e0.svg";
export { ForwardRef as ReactComponent };